"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioCardGroup = void 0;
const react_1 = __importStar(require("react"));
const Row_1 = __importDefault(require("../../Row"));
const RadioCardGroup = ({ col, type, size, gutter, children, disabled, reversed, defaultValue, onChange, onClick, }) => {
    const [selectedValue, setSelectedValue] = (0, react_1.useState)(defaultValue);
    const onChangeHandler = (value) => {
        setSelectedValue(value);
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
    };
    const onClickHandler = (value) => {
        onClick === null || onClick === void 0 ? void 0 : onClick(value);
    };
    return (react_1.default.createElement("section", { className: "gerudo-radio-card-group" },
        react_1.default.createElement(Row_1.default, { gutter: gutter || "small" }, children({
            col,
            size,
            disabled,
            reversed,
            selectedValue,
            type,
            onChange: onChangeHandler,
            onClick: onClickHandler,
        }))));
};
exports.RadioCardGroup = RadioCardGroup;
//# sourceMappingURL=RadioCardGroup.js.map